import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-large);
	padding-bottom: var(--spacing-large);
	flex: 1;
	.list-with-scroll {
		flex: 1;
		gap: var(--spacing-xx-large);
	}
	.error-message-clearence {
		display: flex;
		flex-direction: column;
		gap: var(--spacing-xx-large);
		flex: 1;
	}
`;
